/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_901fc9dd',
  icon: 'icon_901fc9dd',
  themeDarkAltColor: 'themeDarkAltColor_901fc9dd',
  leftText: 'leftText_901fc9dd',
  splitter: 'splitter_901fc9dd',
  button: 'button_901fc9dd',
  darkerBG: 'darkerBG_901fc9dd',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_901fc9dd{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_901fc9dd{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_901fc9dd{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_901fc9dd{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_901fc9dd{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_901fc9dd.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_901fc9dd:hover{background:initial}.darkerBG_901fc9dd{background:#d0d0d0}"}]);
/* tslint:enable */